<template>
  <v-snackbar
    v-model="snackbar"
    :color="status.type"
    :timeout="5000"
    auto-height
    right
    :bottom="$route.meta.public"
    :top="!$route.meta.public"
    :class="computedClass"
  >
    <p v-html="status.message"></p>
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "app-snackbar",
  computed: {
    ...mapState(["status"]),
    snackbar: {
      get() {
        return !!this.status.message;
      },
      set() {
        this.$store.commit("LOADING_DONE");
      }
    },
    computedClass() {
      let cls = "";
      if (!this.$vuetify.breakpoint.xs) cls = "mb-3";
      if (!this.$route.meta.public) cls = "mt-5";
      return cls;
    }
  }
};
</script>
